// Adding the JS to change the variant selector
document.addEventListener("DOMContentLoaded", function(event){
  var variant = document.querySelector('.dynamic-variant-input-wrap');
  if (variant){
    var buttons = variant.querySelectorAll('button'), i = 0, len = buttons.length, regionSizes = [];
    while (i < len){
      var text = buttons[i].textContent.split("|"),
          regex = /[0-9\.]+/,
          replaced = text[0].match(regex);
      regionSizes[i] = {};
      buttons[i].textContent.split("|").forEach(function(str){
        var regex = /[A-Za-z0-9\.]+/,
            regex2 = /(UK|US|EU)/;
        regionSizes[i][str.match(regex2)[0]] = str.match(regex)[0];
      });
      buttons[i].textContent = regionSizes[i]['UK'];
      i++;
    }

    var regionSwitcherContainer = document.querySelector('.product__label-wrapper'),
        label = document.createElement('div'),
        textAndDropdown = document.createElement('div'),
        dropdown = document.createElement('div');
    label.textContent = 'Size';
    textAndDropdown.textContent = 'Show sizes in:'
    dropdown.classList.add('size-dropdown');
    dropdown.innerHTML = '<button class="size-dropbtn"><span>UK</span>&nbsp;&nbsp;<span style="transform:rotate(90deg);display:inline-block;padding-left:3px;">></span></button><div class="size-dropdown-content"><div>UK</div><div>US</div><div>EU</div></div>';
    textAndDropdown.appendChild(dropdown);
    regionSwitcherContainer.textContent = '';
    regionSwitcherContainer.appendChild(label);
    regionSwitcherContainer.appendChild(textAndDropdown);
    var switcher = document.querySelector('.size-dropdown-content'),
        dropbtn = document.querySelector('.size-dropbtn').querySelector('span');
    switcher.addEventListener('click', function(e){
      console.log(e.target,e.target.textContent);
      i = 0;
      console.log(len, i, regionSizes[i][e.target.textContent])
      while (i < len){
        buttons[i].textContent = regionSizes[i][e.target.textContent];
        dropbtn.textContent = e.target.textContent;
        i++;
      } 
    })

    function debounce(func, wait, immediate) {
    	var timeout;
    	return function() {
    		var context = this, args = arguments;
    		var later = function() {
    			timeout = null;
    			if (!immediate) func.apply(context, args);
    		};
    		var callNow = immediate && !timeout;
    		clearTimeout(timeout);
    		timeout = setTimeout(later, wait);
    		if (callNow) func.apply(context, args);
    	};
    };

    var triggerButton = document.getElementById('scrollUp'),
        ctaBtn = document.getElementById('mobileCTA');

    var myEfficientFn = debounce(function() {
      if (window.pageYOffset > 1200){
        if (!ctaBtn.classList.contains('inView')){
          ctaBtn.classList.add('inView');
        }  
      }
      if (window.pageYOffset < 1200){
        if (ctaBtn.classList.contains('inView')){
          ctaBtn.classList.remove('inView');
        }  
      } 
    }, 250);
    
    if (triggerButton){
      document.addEventListener('scroll', myEfficientFn);
      triggerButton.addEventListener('click', function(){
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        ctaBtn.classList.remove('inView')
      })
    }
    
    
  }

  var collectionTextTrigger = document.querySelector('.expand-text-button');

  if (collectionTextTrigger) {
    var truncated = document.querySelector('.truncated'),
        full = document.querySelector('.not-truncated');
    collectionTextTrigger.addEventListener('click', function(e){
      collectionTextTrigger.style.display = 'none';
      truncated.style.display = 'none';
      full.style.display = 'block';
    })
  }
})







// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
